/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinepromptlabel2Inputs */

const en_refinepromptlabel2 = /** @type {(inputs: Refinepromptlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should change?`)
};

const de_refinepromptlabel2 = /** @type {(inputs: Refinepromptlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll geändert werden?`)
};

/**
* | output |
* | --- |
* | "What should change?" |
*
* @param {Refinepromptlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinepromptlabel2 = /** @type {((inputs?: Refinepromptlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinepromptlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinepromptlabel2(inputs)
	return de_refinepromptlabel2(inputs)
});
export { refinepromptlabel2 as "refinePromptLabel" }